import React, { useState, useEffect, useRef } from "react";
import Header from "../../Common/Header/Header";
import Sidebar from "../../Common/Sidebar/Sidebar";
import * as constantMessages from "../../../constants/constatntMessages";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../../node_modules/axios/index";
import "./style/EmailTemplate.css";
import { Html, Head, Body, Container } from "@react-email/components";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import Select from "react-select";
import Spinner from "react-bootstrap/Spinner";
import CircularProgress from "@mui/material/CircularProgress";
import { Button } from "react-bootstrap";

const EmailTemplate = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [moduleNameOptions, setModuleNameOptions] = useState([
    { label: "Select Module Name", value: "" },
  ]);
  const [templateTypeOptions, setTemplateTypeOptions] = useState([
    { label: "Select Template Type", value: "" },
  ]);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [templates, setTemplates] = useState([]);
  const [errors, setErrors] = useState({});
  const [parameterValues, setParameterValues] = useState([]);
  const quillRef = useRef(null);
  const [templateParameters, setTemplateParameters] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [headerProfilePicture, setHeaderProfilePicture] = useState("");
  const [templateForm, setTemplateForm] = useState({
    moduleName: "Meeting",
    templateType: "DEMO_SEND_OTP",
    templateName: "",
    subject: "",
    body: "",
  });
  const [lastUpdatedTemplateType, setLastUpdatedTemplateType] = useState(null);

  useEffect(() => {
    document.title = "Email Template: MinutesVault";
    fetchModules();
  }, []);

  const formatLabel = (text) => {
    return text
      .toLowerCase() // Convert to lowercase
      .replace(
        /(^|\s|_)(\w)/g,
        (_, before, letter) => before + letter.toUpperCase()
      )
      .replace(/_/g, " ");
  };

  const fetchModules = async () => {
    try {
      const orgId = userData?.organizationId;
   
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/V1/emailTemplate/alltemplates/${orgId}`
      );
      const templateMap = {};
      if (Array.isArray(response.data.data.templates)) {
        response.data.data.templates.forEach((template) => {
   

          if (template.templateType && template.parameter) {
            templateMap[template.templateType] = template.parameter;
          }
        });
      }
      setTemplateParameters(templateMap);

      setLoading(false);

      if (response.data && response.data.data.templates.length > 0) {
        const moduleOptions = response.data.data.templates.map((template) => ({
          label: template.moduleName,
          value: template.moduleName,
        }));

        const templateTypeOptions = response.data.data.templates.map(
          (template) => ({
            label: formatLabel(template.templateType), // Apply formatting function
            value: template.templateType,
            id: template._id,
          })
        );

        setModuleNameOptions([
          { label: "Select Module Name", value: "" },
          ...moduleOptions,
        ]);
        setTemplateTypeOptions([...templateTypeOptions]);

        setSelectedTemplate(response.data.data.templates);
        setTemplates(response.data.data.templates);
      }
    } catch (error) {
      console.error("Error fetching modules", error);
      toast.error("Failed to fetch modules. Please try again.");
    }
  };

  const templateType = templateForm.templateType || "";
  const parametersToDisplay = templateParameters[templateType] || [];


  const credentialTypes = [
    "actionForwardedCredentials",//1
    "actionAssignCredentials",
    "actionCompletedCredentials",//2
    "actionReassignRequestCredentials",//3
    "actionCancelCredentials",//4
    "actionReassignRequestRejectCredentials",//5
    "addEmployeeCredentials",//6
    "generateMomCredentials",//7
    "actionReOpenCredentials",//8
    "actionApproveCredentials",//9
    "rescheduleCredentials",//10
    "reSendScheduledMeetingCredentials",//11
    "sendScheduledMeetingCredentials",//12
    "acceptMinutesCredentials",//13
    "meetingCancelCredentials",//14
    "actionAssignToOldAssignedUserCredentials",//15
    "sendCommentCredentials",//16
    "meetingRemindersCredentials",
    "sendActionDueReminderCredentials",
    "draftMeetingCredentials",
    "actionAssignNewCredentials",
    // "sendMomAutoAcceptedCredentials",
    "actionPendingAssignedUserwiseCredentials",
    "actionPendingOrganizationwiseCredentials",
    "actionPendingMeetingCreatorwiseCredentials",
    "adminCommentCredentials",
    "importemployeeCredentials",
    "actionforwardacceptCredentials",
    "actionupdateHostCredentials"
  ];

  const handleTemplateTypeChange = (selectedType) => {
    if (selectedTemplate && selectedTemplate.length > 0) {
      const selectedTemplateObj = selectedTemplate.find(
        (template) => template.templateType === selectedType
      );

      if (selectedTemplateObj) {
        let credentials = null;

        credentialTypes.some((type) => {
          if (selectedTemplateObj[type]) {
            credentials = selectedTemplateObj[type];
            return true;
          }
          return false;
        });
        if (credentials) {
          setTemplateForm({
            moduleName: selectedTemplateObj.moduleName,
            templateType: selectedTemplateObj.templateType,
            templateName: selectedTemplateObj.templateName,
            subject: selectedTemplateObj.subject,
            body: credentials.body,
          });
        } else {
          console.error(
            "No valid credentials found for the selected template."
          );
          resetForm(selectedTemplateObj.templateType);
        }
      } else {
        console.error("No template object found for the selected type.");
        resetForm(selectedType);
      }
    }
  };

  useEffect(() => {
    if (
      selectedTemplate &&
      selectedTemplate.length > 0 &&
      !lastUpdatedTemplateType
    ) {
      const defaultTemplate = selectedTemplate.find(
        (template) => template.templateType === "ADD_EMPLOYEE"
      );

      if (defaultTemplate) {
        let defaultCredentials = null;

        credentialTypes.some((type) => {
          if (defaultTemplate[type]) {
            defaultCredentials = defaultTemplate[type];
            return true;
          }
          return false;
        });

        if (defaultCredentials) {
          setTemplateForm({
            moduleName: defaultTemplate.moduleName,
            templateType: defaultTemplate.templateType,
            templateName: defaultTemplate.templateName,
            subject: defaultTemplate.subject,
            body: defaultCredentials.body,
          });
        }
      }
    }
  }, [selectedTemplate]);

  const resetForm = (templateType) => {
    setTemplateForm({
      moduleName: "Meeting",
      templateType: templateType,
      templateName: "",
      subject: "",
      body: "",
    });
  };

  const validateField = (name, value) => {
    let error = "";
    const validRegex = /^[a-zA-Z0-9 -_!@#$%^&*()+=[\]{}|;:'",.<>?/`~]+$/;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    if (name === "subject") {
      if (!trimmedValue) error = "Subject is required.";
      else if (trimmedValue.length < 5)
        error = "Subject must be at least 5 characters.";
      else if (trimmedValue.length > 200)
        error = "Subject cannot exceed 200 characters.";
      else if (!validRegex.test(trimmedValue)) {
        error =
          "Subject can only contain letters, numbers, spaces, dashes, and underscores.";
      }
    } else if (name === "body") {
      const plainText =
        typeof value === "string"
          ? value
          : value?.replace(/<\/?[^>]+(>|$)/g, "").trim();
      if (!plainText) error = "Body is required.";
      else if (plainText.length < 20)
        error = "Body must be at least 20 characters.";
      else if (plainText.length > 2000)
        error = "Body cannot exceed 2000 characters.";
    } else if (name === "templateName") {
      if (!trimmedValue) error = "Template Name is required.";
      else if (trimmedValue.length < 10)
        error = "Template Name must be at least 10 characters.";
      else if (trimmedValue.length > 100)
        error = "Template Name cannot exceed 100 characters.";
      else if (!validRegex.test(trimmedValue)) {
        error =
          "Template Name can only contain letters, numbers, spaces, dashes, and underscores.";
      }
    } else if (name === "templateType") {
      if (!trimmedValue) error = "Select Template Type.";
    }
    return error;
  };
  const templateTypeOptionsFormatted = templateTypeOptions.map((option) => ({
    label: option.label,
    value: option.value,
    id: option.id,
  }));

  const handleChange = (value, fieldName) => {
    let processedValue =
      fieldName === "body"
        ? typeof value === "string"
          ? value.replace(/<\/?[^>]+(>|$)/g, "").trim()
          : ""
        : typeof value === "string"
          ? value.trim()
          : value;

    setTemplateForm((prevForm) => ({
      ...prevForm,
      [fieldName]: value,
    }));

    const error = validateField(fieldName, processedValue);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: error,
    }));

    console.log(`Validation error for field ${fieldName}:`, error);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasError = false;
    const newErrors = {};

    Object.keys(templateForm).forEach((key) => {
      const value = templateForm[key]?.trim() || "";
      const error = validateField(key, value);
      if (!value || errors[key]) {
        hasError = true;
        newErrors[key] = error;
      }
    });

    setErrors(newErrors);

    if (hasError) {
      console.error("Please fill in all required fields.");
      return;
    }


    setLoading(true);

    try {
      const cleanedForm = {
        ...templateForm,
      };
      const orgId = userData?.organizationId;
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/emailTemplate/email-templates/${orgId}`,
        cleanedForm // Send cleaned form here
      );

      const result = response.data;
      if (result.success) {
        const updatedType = templateForm.templateType;

        // ✅ Set last updated template type
        setLastUpdatedTemplateType(updatedType);

        await fetchModules();

        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setLoading(false);
        setTemplateForm((prev) => ({
          ...prev,
          moduleName: "Meeting",
          templateType: prev.templateType,
          subject: prev.subject,
          body: prev.body,
        }));

        setErrors({
          moduleName: "",
          templateType: "",
          subject: "",
          body: "",
        });
      } else {
        toast.error(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(constantMessages.serverErrorMessage + ' Email Template', {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      // Reset loading state to false after the API call
      setLoading(false);
    }
  };

  const handleDrop = (e, fieldName) => {
    e.preventDefault();
    const draggedText = e.dataTransfer.getData("text");

    setTemplateForm((prevState) => {
      const updatedField = prevState[fieldName]
        ? `${prevState[fieldName]} <span contenteditable="false" class="non-editable">${draggedText}</span>`
        : `<span contenteditable="false" class="non-editable">${draggedText}</span>`;

      return {
        ...prevState,
        [fieldName]: updatedField,
      };
    });
  };

  const handleDragStart = (e, placeholder) => {
    e.dataTransfer.setData("text", placeholder);
  };

  return (
    <div>
      <div className="main-content">
        <div className="email-template-editpage">
          <div className="meeting-header-text">
            <h4>Email Template</h4>
          </div>

          <div className="row">
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="mt-2 table-box responsive-table resp-mt-2">
                {templateTypeOptions.some(
                  (option) => option.value === templateForm.templateType
                ) && (
                    <div className="drag-drop-content">
                      <p>
                        You can edit the email template here. Drag and drop these
                        email tags into the fields:
                      </p>
                      {loading ? (
                        <p>Loading...</p>
                      ) : error ? (
                        <p>{error}</p>
                      ) : (
                        <ul>
                          {parametersToDisplay.length > 0 ? (
                            parametersToDisplay.map((value, index) => (
                              <li
                                key={index}
                                className="draggable-tag"
                                draggable
                                onDragStart={(e) => handleDragStart(e, value)}
                              >
                                <span className="parameter-bg">{value}</span>
                              </li>
                            ))
                          ) : (
                            <li>No parameters available for this template</li>
                          )}
                        </ul>
                      )}
                    </div>
                  )}

                <form>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label className="mb-1 mt-4">
                          Module Name <span className="star-mark"> *</span>
                        </label>
                        <select
                          name="moduleName"
                          value={templateForm.moduleName}
                          onChange={handleChange}
                        >
                          <option value="Meeting">Meeting</option>
                        </select>
                        {errors.moduleName && (
                          <span className="error-message">
                            {errors.moduleName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label className="mb-1">
                          Template Type <span className="star-mark"> *</span>
                        </label>
                        <Select
                          name="templateType"
                          options={templateTypeOptionsFormatted}
                          value={templateTypeOptionsFormatted.find(
                            (option) =>
                              option.value === templateForm.templateType
                          )}
                          onChange={(selectedOption) => {
                            handleChange({
                              target: {
                                name: "templateType",
                                value: selectedOption.value,
                              },
                            });
                            handleTemplateTypeChange(selectedOption.value);
                            setSelectedTemplateId(selectedOption.id);
                          }}
                          isSearchable
                        />
                      </div>
                    </div>

                    {templateForm.templateType &&
                      templateForm.templateType !== "" && (
                        <>
                          <div className="col-12">
                            <div className="form-group">
                              <label className="mb-1">
                                Template Name{" "}
                                <span className="star-mark"> *</span>
                              </label>
                              <input
                                type="text"
                                name="templateName"
                                placeholder="Enter Template Name"
                                onChange={(e) =>
                                  handleChange(e.target.value, "templateName")
                                }
                                value={templateForm.templateName}
                              />
                              {errors.templateName && (
                                <span className="error-message">
                                  {errors.templateName}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="form-group">
                              <label className="mb-1">
                                Subject <span className="star-mark"> *</span>
                              </label>
                              <textarea
                                name="subject"
                                placeholder="Enter Subject"
                                value={templateForm.subject}
                                onChange={(e) =>
                                  handleChange(e.target.value, "subject")
                                }
                                rows="3"
                              />
                              {errors.subject && (
                                <span className="error-message">
                                  {errors.subject}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="form-group">
                              <label className="mb-1">
                                Email Body <span className="star-mark"> *</span>
                              </label>
                              <ReactQuill
                                className="no-margin-p"
                                id="email-body-editor"
                                theme="snow"
                                value={templateForm.body}
                                onChange={(value) =>
                                  handleChange(value, "body")
                                }
                                placeholder="Enter the complete email body"
                                style={{ height: "350px", width: "100%" }}
                                modules={{
                                  toolbar: [
                                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    ["bold", "italic", "underline", "strike"],
                                    [{ align: [] }],
                                    ["link"],
                                    [{ color: [] }, { background: [] }],
                                    ["blockquote", "code-block"],
                                    ["image"],
                                    ["video"],
                                    ["clean"],
                                    ["inspect"],
                                  ],
                                }}
                              />
                            </div>
                          </div>
                          {errors.body && (
                            <span className="error-message body-err-message">
                              {errors.body}
                            </span>
                          )}
                        </>
                      )}
                  </div>
                  <button
                    //  variant=""
                    className="create-meeting-button Mom-btn submit-template-btn"
                    onClick={handleSubmit}
                    disabled={loading}
                    style={{
                      // display: "flex",
                      // alignItems: "center",
                      // justifyContent: "center",
                      // gap: "8px",
                    }}
                  >
                    {loading ? (
                      <>
                        <CircularProgress size={20} sx={{ color: "white" }} />
                        <p>Processing...</p>
                      </>
                    ) : (
                      <p>Submit</p>
                    )}
                  </button>
                </form>
              </div>
            </div>

            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 respmt-20">
              <div className="mt-2 table-box" style={{ height: "fit-content" }}>
                <div className="email-template-view-div">
                  <Html>
                    <Head />
                    <Body>
                      <Container className="email-template-container">
                        <div
                          style={{
                            backgroundColor: "#6f1cc4",
                            color: "#ffffff",
                            padding: "10px",
                            textAlign: "center",
                          }}

                        >
                          <div
                            style={{
                              width: "100%",
                              backgroundColor: "transparent",
                              color: "#ffffff",
                              fontSize: "20px",
                              textAlign: "center",
                            }}
                          >
                            {templateForm.templateName}
                          </div>
                        </div>

                        <div className="template-second-div">
                          {templateForm.subject && (
                            <div>{templateForm.subject}</div>
                          )}

                          <br />

                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(templateForm.body),
                            }}
                          ></div>
                        </div>
                      </Container>
                    </Body>
                  </Html>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplate;
